import { z } from 'zod';

/* Contratos de config de orgs no backoffice (ADR-0569). O admin-service expõe
   `GET /v1/admin/public-email-domains` (list) + `PUT /v1/admin/public-email-domains`
   (super_admin — substitui a lista inteira via read-modify-write no config-service).
   `orgs.publicEmailDomains` barra domínios públicos (gmail.com etc.) como domínio
   `verified` de org (footgun do same-domain auto-join, ADR-0325/0551); esta superfície
   deixa o admin curar a lista (remover gmail p/ cadastrar org com @gmail). */

/* Shape de domínio (lowercase): labels alfanuméricos com hífen interno, separados por
   ponto, terminando num TLD de ≥2 letras. O card lowercaseia antes de validar e o
   service normaliza (lowercase+trim+dedup) antes de persistir. */
export const PUBLIC_EMAIL_DOMAIN_RE = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/;
const MAX_PUBLIC_EMAIL_DOMAINS = 200;
const MAX_DOMAIN_LEN = 253;

export const publicEmailDomainsResponseDto = z.object({ domains: z.array(z.string()) });
export type PublicEmailDomainsResponse = z.infer<typeof publicEmailDomainsResponseDto>;

/* Substitui a lista inteira (RMW no config-service). Cada domínio validado + o service
   normaliza (lowercase+trim) e deduplica antes de persistir. */
export const updatePublicEmailDomainsBody = z.object({
  domains: z
    .array(z.string().min(1).max(MAX_DOMAIN_LEN).regex(PUBLIC_EMAIL_DOMAIN_RE))
    .max(MAX_PUBLIC_EMAIL_DOMAINS),
});
export type UpdatePublicEmailDomainsBody = z.infer<typeof updatePublicEmailDomainsBody>;
